var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Project } from '../../../models/index';
import { LocaleAwareBaseComponent } from './../../../seo/locale-aware-base.component';
var MapPlanProjectMobileBaseComponent = /** @class */ (function (_super) {
    __extends(MapPlanProjectMobileBaseComponent, _super);
    function MapPlanProjectMobileBaseComponent() {
        return _super.call(this) || this;
    }
    return MapPlanProjectMobileBaseComponent;
}(LocaleAwareBaseComponent));
export { MapPlanProjectMobileBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/map-plan/map-plan-project-mobile-base.component.ts.pre-build-optimizer.js